import Swiper, { Scrollbar } from 'swiper';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Scrollbar]);

var projectNewsSlider = new Swiper('.js-news-slider', {
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
  },
  navigation: {
    nextEl: '.js-news-slider-btn-next',
    prevEl: '.js-news-slider-btn-prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 1.25,
      spaceBetween: 16,
    },
    560: {
      slidesPerView: 2.3,
    },
    768: {
      slidesPerView: 3.35,
    },
    1024: {
      slidesPerView: 3.25,
      spaceBetween: 30,
    },
  },
});

var projectRelatedProjectsSlider = new Swiper('.js-related-projects-slider', {
  spaceBetween: 16,
  navigation: {
    nextEl: '.js-related-projects-slider-btn-next',
    prevEl: '.js-related-projects-slider-btn-prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 1.25,
      spaceBetween: 16,
    },
    560: {
      slidesPerView: 2.3,
    },
    768: {
      slidesPerView: 3.35,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
});

var projectClientsSlider = new Swiper('.js-our-clients-slider', {
  spaceBetween: 16,
  navigation: {
    nextEl: '.js-our-clients-slider-btn-next',
    prevEl: '.js-our-clients-slider-btn-prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 2.3,
      spaceBetween: 16,
    },
    560: {
      slidesPerView: 3.35,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
});

var projectAwardsSlider = new Swiper('.js-new-awards-slider', {
  spaceBetween: 16,
  navigation: {
    nextEl: '.js-awards-slider-btn-next',
    prevEl: '.js-awards-slider-btn-prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 1.25,
      spaceBetween: 16,
    },
    560: {
      slidesPerView: 2.3,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});

var projectServicesSlider = new Swiper('.js-our-services-slider', {
  spaceBetween: 16,
  navigation: {
    nextEl: '.js-our-services-slider-btn-next',
    prevEl: '.js-our-services-slider-btn-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
  },
  breakpoints: {
    320: {
      slidesPerView: 1.25,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 2.25,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 2.3,
      spaceBetween: 30,
    },
  },
});

const leasingSlider = document.querySelector('.js-leasing-slider');

if (leasingSlider) {
  const leasingSliderTitles = leasingSlider.dataset?.titles;

  var projectLeasing = new Swiper('.js-leasing-slider', {
    spaceBetween: 16,
    pagination: {
      el: '.js-leasing-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return leasingSliderTitles
          ? '<span class="' +
              className +
              '">' +
              JSON.parse(leasingSliderTitles)[index] +
              '</span>'
          : null;
      },
    },
    breakpoints: {
      320: {
        slidesPerView: 1.25,
        spaceBetween: 16,
        allowTouchMove: true,
      },
      560: {
        slidesPerView: 2.3,
        spaceBetween: 16,
      },
      740: {
        slidesPerView: 1,
        allowTouchMove: false,
        spaceBetween: 0,
      },
    },
  });
}

var projectGallerySlider = new Swiper('.js-project-gallery-slider-v2', {
  spaceBetween: 16,
  breakpoints: {
    320: {
      slidesPerView: 1.25,
      spaceBetween: 16,
    },
    560: {
      slidesPerView: 2.3,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 4.2,
      spaceBetween: 16,
    },
  },
});

// Project Keys slider, which will init only on mobiles
// Source: https://medium.com/@networkaaron/swiper-how-to-destroy-swiper-on-min-width-breakpoints-a947491ddec8
// breakpoint where swiper will be destroyed
const breakpointMD = window.matchMedia('(min-width:740px)');
const projectKeysEls = document.getElementsByClassName('js-project-keys');
// keep track of swiper instances to destroy later
let projectKeysSlider;

const breakpointChecker = function () {
  // if larger viewport and multi-row layout needed
  if (breakpointMD.matches === true) {
    // clean up old instances and inline styles when available
    if (projectKeysSlider !== undefined) {
      projectKeysSlider.destroy(true, true);
    }
    // or/and do nothing
    return;
    // else if a small viewport and single column layout needed
  } else if (breakpointMD.matches === false) {
    // fire small viewport version of swiper
    return enableKeysSwiper();
  }
};

const enableKeysSwiper = function () {
  projectKeysSlider = new Swiper('.js-project-keys', {
    spaceBetween: 16,
    breakpoints: {
      320: {
        slidesPerView: 1.25,
        spaceBetween: 16,
      },
      560: {
        slidesPerView: 2.3,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
    },
  });
};

if (projectKeysEls.length > 0) {
  // keep an eye on viewport size changes
  breakpointMD.addEventListener('change', breakpointChecker);

  // kickstart
  breakpointChecker();
}

// BBC WB sliders
var bbcWbRelatedArticlesSlider = new Swiper(
  '.js-bbc-wb-related-articles-slider',
  {
    spaceBetween: 16,
    navigation: {
      nextEl: '.js-bbc-wb-related-articles-slider-btn-next',
      prevEl: '.js-bbc-wb-related-articles-slider-btn-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.3,
      },
      560: {
        slidesPerView: 2.3,
      },
      768: {
        slidesPerView: 2.3,
      },
      1024: {
        slidesPerView: 3.2,
      },
      1200: {
        spaceBetween: 32,
        slidesPerView: 3,
      },
    },
  },
);

var bbcWbRelatedProjectsSlider = new Swiper(
  '.js-bbc-wb-related-projects-slider',
  {
    spaceBetween: 16,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: '.js-bbc-wb-related-projects-slider-btn-next',
      prevEl: '.js-bbc-wb-related-projects-slider-btn-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.25,
      },
      560: {
        slidesPerView: 2.3,
      },
      768: {
        slidesPerView: 3.35,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 32,
      },
    },
  },
);
